<div class="invitation-resent text-center">
    <div class="invitation-resent__illu align-center">
        <img src="assets/images/partner/paper_plane.svg"
             [alt]="'Invitation renvoyee' | transloco" />
    </div>
    <div class="invitation-resent__content">
        <div class="invitation-resent__title">
            {{'Invitation envoyee !' | transloco }}
        </div>
        <p class="invitation-resent__subtitle margin-bottom-50">
            {{'Une copie de l\'e-mail d\'invitation vient d\'etre envoyee au responsable legal de $orga$.' | transloco: { orga: invitation.extras?.partner?.name} }}
            <div class="invitation-resent__buttons">
                <div class="dashboard-link">
                    <a [href]="managerLink"
                       mat-flat-button
                       color="primary">
                        {{'Terminer' | transloco}}
                    </a>
                </div>
            </div>
    </div>
</div>
